import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=3a116d32&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a116d32')) {
      api.createRecord('3a116d32', component.options)
    } else {
      api.reload('3a116d32', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=3a116d32&", function () {
      api.rerender('3a116d32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/paginate/Paginate.vue"
export default component.exports